import { ExternalEntityAssociationViewModel } from '../../models/Entities/Person/ExternalAssociation/ExternalAssociationModels';
import { CommonState } from '../common/state/commonState';

export interface PersonExternalAssociationState extends CommonState<ExternalEntityAssociationViewModel> {
    lastCreated?: ExternalEntityAssociationViewModel;
}

export const PersonExternalAssociationUnloadState: PersonExternalAssociationState = {
    isLoadingAll: false,
    successLoadingAll: undefined,
    failOnLoadingAll: false,

    isLoadingOne: false,
    successLoadingOne: undefined,
    failOnLoadingOne: false,

    isAddingNewOne: false,
    successAddingNewOne: undefined,
    failOnAddingNewOne: false,

    isUpdatingOne: false,
    successUpdatingOne: undefined,
    failOnUpdatingOne: false,

    isDeletingOne: false,
    successDeletingOne: undefined,
    failOnDeletingOne: false,

    list: [],
    error: undefined,
    lastCreated: undefined
};
